
































































import { Component, Vue, Prop } from "vue-property-decorator";
import Basic from "../components/basic.vue";
import ZhenciMsg from "../components/zhenci-msg.vue";
import { GetBingliDetail } from "@/request/common";
import Chart from "@/components/chart.vue";
@Component({
  components: {
    Basic,
    ZhenciMsg,
    Chart,
  },
})
export default class Name extends Vue {
  private id: any = "";
  private cTab: any = "基本信息";
  private data: any = {};
  private get user() {
    return this.$store.state.user;
  }
  private getMsg() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        medcase_id: this.id,
      },
    };
    GetBingliDetail(this, params, loading).then((res: any) => {
      this.data = res;
    });
  }
  private mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.getMsg();
  }
}
